
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-principles",
      function () {
        return require("private-next-pages/learning-principles.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-principles"])
      });
    }
  